import { createContext, useContext } from 'react';

const managerContext = createContext<boolean>(false);

export const IsManagerProvider = managerContext.Provider;
export const useIsManager = () => ({ isManager: useContext(managerContext) });
